import React from 'react';
import { motion } from 'framer-motion';
import {Link, useNavigate} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowRight } from 'react-icons/fa';
import './ContactCTA.css';

interface ContactCTAProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
  background?: string;
  textColor?: string;
  showQuoteButton?: boolean;
}

const ContactCTA: React.FC<ContactCTAProps> = ({ 
  title, 
  subtitle, 
  buttonText, 
  buttonLink = '/contact',
  background = 'var(--primary-color)',
  textColor = 'white',
  showQuoteButton = true
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();


  // Use provided text or default to translations
  const ctaTitle = title || t('contact.title');
  const ctaSubtitle = subtitle || t('contact.subtitle');
  const ctaButtonText = buttonText || t('contact.title');


  const handleLinkClick = (path: string) => {
    window.scrollTo(0, 0);
    navigate(path);
  };
  
  return (
    <section 
      className="cta-section" 
      style={{ backgroundColor: background, color: textColor }}
    >
      <div className="container">
        <div className="cta-content">
          <div className="cta-text-content">
            <motion.h2
              className="cta-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {ctaTitle}
            </motion.h2>
            
            <motion.p
              className="cta-subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              {ctaSubtitle}
            </motion.p>
          </div>
          
          <motion.div
            className="cta-button-container"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Link className="cta-button" to={buttonLink} onClick={() => handleLinkClick(buttonLink)} >
              {ctaButtonText}
              <FaArrowRight />
            </Link>
            
            {showQuoteButton && (
              <button 
                className="quote-button"
                onClick={() => handleLinkClick('/quote')}
              >
                {t('quote.request_quote')}
              </button>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
